{
  "lang": "nl",
  "theme": "stibbe-tabs",
  "plugins": [
    "a11y-describedby",
    "a11y-user-detect",
    "ask-to-stop",
    "asterisk",
    "authorize-internal-links",
    "auto-next-when-only-radio",
    "autosize",
    "autosize-on",
    "bb-input-wrap-and-unit",
    "broadcast-fields",
    "broadcast-fields--receiver",
    "case-template",
    "collapsable-jumplist",
    "control-filter",
    "cors",
    "hacks:blank",
    "has-no-next",
    "history",
    "info-per-question",
    "info-template",
    "language-auto-switch",
    "longlabel",
    "markdown-it",
    "markdown-it-converter",
    "md-labels",
    "modelinfo",
    "no-logout",
    "no-models",
    "no-settings",
    "no-tooltip",
    "or-other",
    "popup-internal-links",
    "popup-links-strict",
    "previews",
    "previews-autoload-first",
    "progressbar",
    "questionlabelgroup-ng",
    "reset-password",
    "selected-model",
    "show-server-side-validation",
    "tabs",
    "theme-stibbe-ng",
    "trim-labels"
  ],
  "arbitrary": {
    "languageLayers": {
      "base-layer": "bb.html",
      "en-us": "tabs-en.html",
      "nl-nl": "bb.html"
    },
    "showdown": {
      "policy": "legacy"
    },
    "previews": {
      "showChanges": true
    }
  },
  "template": {
    "no-header": true,
    "readonly-prop": "disabled"
  },
  "legacy": false
}
